<template>
    <li v-bind:class="{'uk-open': ukOpen}">
        <a class="uk-accordion-title" href="#">
            <span>{{ translations.brand }}</span>
            <i class="fa-solid fa-chevron-down"></i>
        </a>

        <div class="uk-accordion-content">
            <ul class="sidebar__nav">
                <filter-sidebar-brands-item
                    v-for="brand in brands"
                    v-model="localActiveBrands[brand.id]"
                    :brand="brand"
                    :key="brand.key"
                    @input="handleChange"
                    :default-checked="localActiveBrands[brand.id] || false"
                >
                </filter-sidebar-brands-item>
            </ul>
        </div>
    </li>
</template>

<script>
export default {
    name: "FilterSidebarBrands",
    mounted() {
        
    },
    data() {
        return {
            localActiveBrands: this.activeBrands
        }
    },
    methods: {
        handleChange() {
            this.$emit('input', this.localActiveBrands);
        }
    },
    props: {
        brands: {
            type: Object|Array,
            required: true
        },
        translations: {
            type: Object|Array,
            required: true
        },
        activeBrands: {
            type: Object|Array,
            required: true
        },
        ukOpen: {
          type: Boolean,
          required: false,
          default: true
        }
    }
}
</script>

<style scoped>
</style>